import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createSlots as _createSlots, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_steps = _resolveComponent("steps")!
  const _component_icon_sprite = _resolveComponent("icon-sprite")!
  const _component_infotext = _resolveComponent("infotext")!
  const _component_abschluss = _resolveComponent("abschluss")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_steps, {
      items: _ctx.navItems,
      active: 3,
      onGotoPage: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('goto-page', $event)))
    }, null, 8, ["items"]),
    _createVNode(_component_abschluss, {
      produkt: "hg",
      "zeige-versichertes-objekt": true,
      "zeige-tarif": true,
      "zeige-objekt-anschrift": true,
      "zeige-selbstbeteiligung": false,
      "zeige-anzahl-vorschaeden": true,
      "zeige-eigentumsverhaeltnisse": false,
      onNextPage: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('next-page', $event))),
      onGotoPage: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('goto-page', $event)))
    }, _createSlots({
      "versichertes-objekt": _withCtx(() => [
        (_ctx.piniaStore.state.gebaeudedaten.unbebautesGruendstueck === true)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
              _createElementVNode("strong", null, [
                _createTextVNode(" Unbebautes Grundstück, " + _toDisplayString(_ctx.piniaStore.state.gebaeudedaten.flaecheUnbebautesGrundstueck) + "m", 1),
                _cache[4] || (_cache[4] = _createElementVNode("sup", null, "2", -1))
              ])
            ]))
          : _createCommentVNode("", true),
        (
          _ctx.piniaStore.state.gebaeudedaten.gebaeudetyp === '0006' &&
          _ctx.piniaStore.state.gebaeudedaten.unbebautesGruendstueck === false
        )
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.piniaStore.state.gebaeudedaten.anzahlStellplaetzeGaragen) + " " + _toDisplayString(_ctx.piniaStore.state.gebaeudedaten.anzahlStellplaetzeGaragen === 1
              ? "Garage oder Stellplatz"
              : "Garagen und/oder Stellplätze"), 1)
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_3, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.gebaeudeTyp) + _toDisplayString(_ctx.wohnungsAnzahl) + _toDisplayString(_ctx.anzahlGewerbe) + _toDisplayString(_ctx.leerstandProzent), 1)
            ]))
      ]),
      _: 2
    }, [
      (_ctx.piniaStore.state.isMakler)
        ? {
            name: "angaben-bestaetigen",
            fn: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.antragGemaessAngabenTextMakler), 1)
            ]),
            key: "0"
          }
        : {
            name: "angaben-bestaetigen",
            fn: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.antragGemaessAngabenText) + " ", 1),
              (_ctx.piniaStore.state.gebaeudedaten.unbebautesGruendstueck === false)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "c-notice-icon",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.wechsleSichtbarkeit('gewerbeHilfe')))
                  }, [
                    _createVNode(_component_icon_sprite, { "icon-name": "icon-info-i" })
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_infotext, {
                name: "gewerbeHilfe",
                text: _ctx.gebaeudeInfoText
              }, null, 8, ["text"])
            ]),
            key: "1"
          },
      (_ctx.piniaStore.state.isMakler)
        ? {
            name: "gewerbe-zulaessig",
            fn: _withCtx(() => [
              _cache[5] || (_cache[5] = _createTextVNode(" Hiermit bestätige ich, dass sich nur zulässiges Gewerbe an der Risikoanschrift befindet. "))
            ]),
            key: "2"
          }
        : undefined
    ]), 1024)
  ], 64))
}